import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import SelectInput from './SelectInput'; 
import RadioInput from './RadioInput';
import { getProfesiones, getFormularioAnamnesis } from './getData'; 
import { useForm } from 'react-hook-form';
// import '../styles/Anamnesis.css';
import TextInput from './TextInput';

const AnamnesisFormulario = () => {
    const { register, handleSubmit } = useForm();
    const [profesiones, setProfesiones] = useState([]);
    const [anamnesis, setAnamnesis] = useState([]);
    const [selectedMetrics, setSelectedMetrics] = useState({
        frecuencia: null,
        tiempo_uso_horas: null,
        tiempo_uso_anios: null,
    });

    // Obtener interesadoId desde los parámetros de la URL
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const interesadoId = queryParams.get('interesadoId'); // Extraer interesadoId de la URL

    useEffect(() => {
        getProfesiones().then(data => {
            setProfesiones(data);
        }).catch(error => {
            // Error al obtener las profesiones desde la API
            console.error('Error setting profesiones:', error);
        });
    }, []); 

    // Obtener el formulario de anamnesis con el interesadoId
    useEffect(() => {
        if (interesadoId) {
            getFormularioAnamnesis(interesadoId).then(data => {
                setAnamnesis(data);
            }).catch(error => {
                // Error al obtener el formulario de anamnesis
                console.error('Error fetching formulario anamnesis:', error);
            });
        }
    }, [interesadoId]); // Ejecutar cuando el interesadoId esté disponible
    
    const handleRadioChange = (e) => {
        const selectedValue = e.target.value;
        const selectedAnamnesis = anamnesis.filter(a => ["30", "31", "32"].includes(a.det_codigo)); // Aquí puedes cambiar la lógica para seleccionar el anamnesis correcto
        selectedAnamnesis.forEach(item => {
            const alternativaSeleccionada = item.alternativa.find(a => a.alt_codigo === selectedValue);
            if (alternativaSeleccionada && alternativaSeleccionada.alt_descripcion === "SI") {
                if (item.det_codigo === "30") {
                    setSelectedMetrics(prev => ({ ...prev, frecuencia: alternativaSeleccionada.metrica }));
                } else if (item.det_codigo === "31") {
                    setSelectedMetrics(prev => ({ ...prev, tiempo_uso_horas: alternativaSeleccionada.metrica }));
                } else if (item.det_codigo === "32") {
                    setSelectedMetrics(prev => ({ ...prev, tiempo_uso_anios: alternativaSeleccionada.metrica }));
                }
            }
        });
    };

    const onSubmit = (data) => {
        const payload = {
            ...data,
            id_cita: 30
        };
        axios.post(`${process.env.REACT_APP_API_URL_CREARFORMULARIOANAMNESIS}`, payload, {
            headers: {
                Authorization: `Bearer ${process.env.REACT_APP_BEARER_TOKEN}`
            }
        })
        .then(response => {
            // Respuesta exitosa del servidor al registrar anamnesis
            // console.log(response.data);
            alert(response.data.message); 
        })
        .catch(error => {
            // Error al registrar la reserva en el servidor
            console.error('Hubo un problema al registrar la reserva.', error);
            alert('Hubo un problema al registrar la reserva.'); 
        });
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="anamnesisformulario-container">
            <div className="row">
                <div className="container-izquierda">
                    <SelectInput 
                        id="prf_codigo"
                        label="Ocupación o Profesión"
                        options={profesiones.map(p => ({ value: p.prf_codigo, label: p.prf_denominacion }))}
                        valueKey="value"
                        labelKey="label"
                        {...register('prf_codigo')}
                    />
                    <RadioInput 
                        id="dispositivos"
                        name="dispositivos"
                        label="Uso dispositivos electrónicos:"
                        options={[{value:21, label: "SI"},{value:22, label: "NO"}]}
                        register={register}
                        onChange={handleRadioChange}
                    />
                    <RadioInput 
                        id="monturas"
                        name="monturas"
                        label="Usuario de monturas óptica:"
                        options={[{value:23, label: "SI"},{value:24, label: "NO"}]}
                        register={register}
                        onChange={handleRadioChange}
                    />
                    <RadioInput 
                        id="lentes"
                        name="lentes"
                        label="Usuario de lentes de contacto:"
                        options={[{value:25, label: "SI"},{value:26, label: "NO"}]}
                        register={register}
                        onChange={handleRadioChange}
                    />
                </div>
                <div className="container-derecha">
                    <TextInput 
                        id="ana_actividad" 
                        label="Otra Actividad" 
                        {...register('ana_actividad')} 
                    />
                    {selectedMetrics.frecuencia && (
                        <SelectInput 
                            id="frecuencia"
                            label="Frecuencias (Horas)"
                            options={selectedMetrics.frecuencia.map(m => ({ value: m.mtr_codigo, label: m.mtr_descripcion }))}
                            valueKey="value"
                            labelKey="label"
                            {...register('frecuencia')}
                        />
                    )}
                    {selectedMetrics.tiempo_uso_horas && (
                        <SelectInput 
                            id="tiempo_uso_horas"
                            label="Tiempo de Uso (Horas)"
                            options={selectedMetrics.tiempo_uso_horas.map(m => ({ value: m.mtr_codigo, label: m.mtr_descripcion }))}
                            valueKey="value"
                            labelKey="label"
                            {...register('tiempo_uso_horas')}
                        />
                    )}
                    {selectedMetrics.tiempo_uso_anios && (
                        <SelectInput 
                            id="tiempo_uso_anios"
                            label="Tiempo de Uso (Años)"
                            options={selectedMetrics.tiempo_uso_anios.map(m => ({ value: m.mtr_codigo, label: m.mtr_descripcion }))}
                            valueKey="value"
                            labelKey="label"
                            {...register('tiempo_uso_anios')}
                        />
                    )}
                </div>
            </div>
            <div className="container-central">
                <div className="column-1">
                    <RadioInput 
                        id="ojos_rojos"
                        name="ojos_rojos"
                        label="Ojos rojos:"
                        options={[{value:27, label: "SI"},{value:28, label: "NO"}]}
                        register={register}
                    />
                    <RadioInput 
                        id="dolor_de_cabeza"
                        name="dolor_de_cabeza"
                        label="Dolor de cabeza al leer:"
                        options={[{value:33, label: "SI"},{value:34, label: "NO"}]}
                        register={register}
                    />
                </div>
                <div className="columnn-2">
                    <RadioInput 
                        id="picor_u_ardor"
                        name="picor_u_ardor"
                        label="Picor u ardor al leer:"
                        options={[{value:29, label: "SI"},{value:30, label: "NO"}]}
                        register={register}
                    />
                    <RadioInput 
                        id="molestia_computadora"
                        name="molestia_computadora"
                        label="Molestia uso de computadora:"
                        options={[{value:35, label: "SI"},{value:36, label: "NO"}]}
                        register={register}
                    />
                </div>
                <div className="columnn-3">
                    <RadioInput 
                        id="resequedad"
                        name="resequedad"
                        label="Resequedad:"
                        options={[{value:31, label: "SI"},{value:32, label: "NO"}]}
                        register={register}
                    />
                    <RadioInput 
                        id="secrecion"
                        name="secrecion"
                        label="Secreción:"
                        options={[{value:37, label: "SI"},{value:38, label: "NO"}]}
                        register={register}
                    />
                </div>
            </div>
            <button type='submit' className='enviar-formulario'>
                ENVIAR FORMULARIO
            </button>
        </form>
    );
};

export default AnamnesisFormulario;
